<template>
  <div class="container">
    <div class="menu">
      <ul>
        <li @click="play(1)"><a>1、南食堂调料库</a></li>
        <li @click="play(2)"><a>2、南食堂快检库</a></li>
        <li @click="play(5)"><a>3、南食堂主食库</a></li>
        <li @click="play(6)"><a>4、南食堂速切间</a></li>
        <li @click="play(7)"><a>5、南食堂洗消间</a></li>
        <li @click="play(9)"><a>6、南食堂面点区</a></li>
        <li @click="play(4)"><a>7、南食堂烹饪区-1</a></li>
        <li @click="play(8)"><a>8、南食堂烹饪区-2</a></li>
        <li @click="play(10)"><a>9、南食堂冰箱间-1</a></li>
        <li @click="play(3)"><a>10、南食堂冰箱间-2</a></li>
        <li @click="play(11)"><a>11、北食堂冰箱间</a></li>
        <li @click="play(12)"><a>12、北食堂洗碗间</a></li>
        <li @click="play(14)"><a>13、北食堂主食库</a></li>
        <li @click="play(13)"><a>14、北食堂烹饪区-1</a></li>
        <li @click="play(15)"><a>15、北食堂烹饪区-2</a></li>
        <li @click="play(16)"><a>16、北食堂速切区</a></li>
        <li @click="play(18)"><a>17、北食堂调料库</a></li>
        <li @click="play(19)"><a>18、北食堂快检库</a></li>
        <li @click="play(20)"><a>19、北食堂面点一区</a></li>
        <li @click="play(17)"><a>20、北食堂面点二区</a></li>



      </ul>
    </div>
    <div class="video">
      <video
        poster="../assets/2ab7b812dd9447818e0bbfa2ea0f321f.jpg"
        ref="videoPlayer"
        controls
      ></video>
    </div>
  </div>
  <div></div>
</template>

<script>
import flvjs from "flv.js";

export default {
  data() {
    return {
      flvPlayer: null,
      videoElement: null,
    };
  },
  mounted() {
    this.videoElement = this.$refs.videoPlayer;
    this.flvPlayer = flvjs.createPlayer({
      type: "flv",
      url: "http://222.223.251.25:8002/live/livestream101.flv",
    });
    this.flvPlayer.attachMediaElement(this.videoElement);
    this.flvPlayer.load();
    this.flvPlayer.play();
  },
  methods: {
    beforeDestroy() {
      if (this.flvPlayer) {
        this.flvPlayer.pause();
        this.flvPlayer.unload();
        this.flvPlayer.detachMediaElement();
        this.flvPlayer.destroy();
      }
    },
    play(id) {
      this.beforeDestroy();
      switch (id) {
        case 1:
          this.flvPlayer = flvjs.createPlayer({
            type: "flv",
            url: "http://222.223.251.25:8002/live/livestream101.flv",
          });
          this.flvPlayer.attachMediaElement(this.videoElement);
          this.flvPlayer.load();
          this.flvPlayer.play();
          break;
        case 2:
          this.flvPlayer = flvjs.createPlayer({
            type: "flv",
            url: "http://222.223.251.25:8002/live/livestream201.flv",
          });
          this.flvPlayer.attachMediaElement(this.videoElement);
          this.flvPlayer.load();
          this.flvPlayer.play();
          break;
        case 3:
          this.flvPlayer = flvjs.createPlayer({
            type: "flv",
            url: "http://222.223.251.25:8002/live/livestream301.flv",
          });
          this.flvPlayer.attachMediaElement(this.videoElement);
          this.flvPlayer.load();
          this.flvPlayer.play();
          break;
        case 4:
          this.flvPlayer = flvjs.createPlayer({
            type: "flv",
            url: "http://222.223.251.25:8002/live/livestream401.flv",
          });
          this.flvPlayer.attachMediaElement(this.videoElement);
          this.flvPlayer.load();
          this.flvPlayer.play();
          break;
        case 5:
          this.flvPlayer = flvjs.createPlayer({
            type: "flv",
            url: "http://222.223.251.25:8002/live/livestream501.flv",
          });
          this.flvPlayer.attachMediaElement(this.videoElement);
          this.flvPlayer.load();
          this.flvPlayer.play();
          break;
        case 6:
          this.flvPlayer = flvjs.createPlayer({
            type: "flv",
            url: "http://222.223.251.25:8002/live/livestream6601.flv",
          });
          this.flvPlayer.attachMediaElement(this.videoElement);
          this.flvPlayer.load();
          this.flvPlayer.play();
          break;
        case 7:
          this.flvPlayer = flvjs.createPlayer({
            type: "flv",
            url: "http://222.223.251.25:8002/live/livestream701.flv",
          });
          this.flvPlayer.attachMediaElement(this.videoElement);
          this.flvPlayer.load();
          this.flvPlayer.play();
          break;
        case 8:
          this.flvPlayer = flvjs.createPlayer({
            type: "flv",
            url: "http://222.223.251.25:8002/live/livestream801.flv",
          });
          this.flvPlayer.attachMediaElement(this.videoElement);
          this.flvPlayer.load();
          this.flvPlayer.play();
          break;
        case 9:
          this.flvPlayer = flvjs.createPlayer({
            type: "flv",
            url: "http://222.223.251.25:8002/live/livestream901.flv",
          });
          this.flvPlayer.attachMediaElement(this.videoElement);
          this.flvPlayer.load();
          this.flvPlayer.play();
          break;
        case 10:
          this.flvPlayer = flvjs.createPlayer({
            type: "flv",
            url: "http://222.223.251.25:8002/live/livestream1001.flv",
          });
          this.flvPlayer.attachMediaElement(this.videoElement);
          this.flvPlayer.load();
          this.flvPlayer.play();
          break;
          case 11:
          this.flvPlayer = flvjs.createPlayer({
            type: "flv",
            url: "http://222.223.251.25:8002/live/livestream1101.flv",
          });
          this.flvPlayer.attachMediaElement(this.videoElement);
          this.flvPlayer.load();
          this.flvPlayer.play();
          break;
          case 12:
          this.flvPlayer = flvjs.createPlayer({
            type: "flv",
            url: "http://222.223.251.25:8002/live/livestream1201.flv",
          });
          this.flvPlayer.attachMediaElement(this.videoElement);
          this.flvPlayer.load();
          this.flvPlayer.play();
          break;
          case 13:
          this.flvPlayer = flvjs.createPlayer({
            type: "flv",
            url: "http://222.223.251.25:8002/live/livestream1301.flv",
          });
          this.flvPlayer.attachMediaElement(this.videoElement);
          this.flvPlayer.load();
          this.flvPlayer.play();
          break;
          case 14:
          this.flvPlayer = flvjs.createPlayer({
            type: "flv",
            url: "http://222.223.251.25:8002/live/livestream1401.flv",
          });
          this.flvPlayer.attachMediaElement(this.videoElement);
          this.flvPlayer.load();
          this.flvPlayer.play();
          break;
          case 15:
          this.flvPlayer = flvjs.createPlayer({
            type: "flv",
            url: "http://222.223.251.25:8002/live/livestream1501.flv",
          });
          this.flvPlayer.attachMediaElement(this.videoElement);
          this.flvPlayer.load();
          this.flvPlayer.play();
          break;
          case 16:
          this.flvPlayer = flvjs.createPlayer({
            type: "flv",
            url: "http://222.223.251.25:8002/live/livestream1601.flv",
          });
          this.flvPlayer.attachMediaElement(this.videoElement);
          this.flvPlayer.load();
          this.flvPlayer.play();
          break;
          case 17:
          this.flvPlayer = flvjs.createPlayer({
            type: "flv",
            url: "http://222.223.251.25:8002/live/livestream1701.flv",
          });
          this.flvPlayer.attachMediaElement(this.videoElement);
          this.flvPlayer.load();
          this.flvPlayer.play();
          break;
          case 18:
          this.flvPlayer = flvjs.createPlayer({
            type: "flv",
            url: "http://222.223.251.25:8002/live/livestream1801.flv",
          });
          this.flvPlayer.attachMediaElement(this.videoElement);
          this.flvPlayer.load();
          this.flvPlayer.play();
          break;
          case 19:
          this.flvPlayer = flvjs.createPlayer({
            type: "flv",
            url: "http://222.223.251.25:8002/live/livestream1901.flv",
          });
          this.flvPlayer.attachMediaElement(this.videoElement);
          this.flvPlayer.load();
          this.flvPlayer.play();
          break;
          case 20:
          this.flvPlayer = flvjs.createPlayer({
            type: "flv",
            url: "http://222.223.251.25:8002/live/livestream11001.flv",
          });
          this.flvPlayer.attachMediaElement(this.videoElement);
          this.flvPlayer.load();
          this.flvPlayer.play();
          break;
      }
    },
  },
};
</script>
<style scoped>
body {
  margin: 0;
  padding: 0;
}
.container {
  display: flex;
}
.menu {
  flex: 1;
  height: calc(100vh - 80px);
  background-color: white;
  color: #444444;
  border-right: 1px solid #dedede;
}
.menu ul {
  list-style: none;
  padding: 40px 20px;
  margin: 0;
  font-size: 18px;
}
.menu li {
  padding: 5px;
  cursor: pointer;
  text-align: left;
  margin-left: 10px;
}
.menu li:hover {
  text-decoration: underline;
}
.video {
  flex: 5;
  position: relative;
}
.video video {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
}
a:visited {
  color: blue;
} /*光标在标签上时，显示另一种颜色*/
@media (max-width: 767px) {
  .container {
    flex-wrap: nowrap;
    flex-direction: column;
    margin-bottom: 20px;
  }
  .menu ul[data-v-469af010] {
    list-style: none;
    padding: 20px 20px;
    margin: 0;
    font-size: 18px;
  }
  .menu li {
    padding: 6px;
    cursor: pointer;
    text-align: left;
    margin-left: 10px;
  }

  .menu {
    height: auto;
    flex: none;
    border-right: 0px solid #dedede;
    margin-top: 200px;
  }
  .video video {
    flex: none;
    width: 100%;
  }
  .video{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    right: 0;
    height: auto;
  }
  .video video {
  position: inherit;
  left: 0;
  right: 0;
  top: 0;
  transform:translate(0)
}
}
</style>